import { Vector as VectorLayer } from 'ol/layer.js';
import { Vector as VectorSource } from 'ol/source.js';
import { Style, Icon } from 'ol/style.js';
import Draw from 'ol/interaction/Draw.js';
import { transform } from 'ol/proj';
import proj4 from 'proj4';

var sourceLocation = new VectorSource();
var vectorLocation = new VectorLayer({
  source: sourceLocation,
  zIndex: 2000, 
  style: new Style({
    image: new Icon({
      anchor: [0.5, 1],
      src: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
      scale: 0.5,
      crossOrigin: 'anonymous'
    })
  })
});

var drawPoint;

export const measureLocation = {
  data() {
    return {
      fixedPoint: null,    // El punto marcado con clic
      pointerPoint: null   // El punto que sigue al mouse
    }
  },
  methods: {
    addMeasureLocationInteraction() {
      var that = this;
      if (!this.map) return;

      const layers = this.map.getLayers().getArray();
      if (!layers.includes(vectorLocation)) {
        this.map.addLayer(vectorLocation);
      }

      // 1. Interacción para el Punto Fijo (Clic)
      if (drawPoint) this.map.removeInteraction(drawPoint);
      drawPoint = new Draw({
        source: sourceLocation,
        type: 'Point',
        style: new Style({}) // Sin previsualización de dibujo
      });

      drawPoint.on('drawstart', function() {
        sourceLocation.clear(); // Solo permitimos 1 punto: borrar el anterior
      });

      drawPoint.on('drawend', function(evt) {
        const coordinate = evt.feature.getGeometry().getCoordinates();
        const displayCoord = transform(coordinate, that.map.getView().getProjection(), 'EPSG:4326');
        
        that.fixedPoint = {
          lat: displayCoord[1],
          lon: displayCoord[0],
          dms: that.formatToDMS(displayCoord[1], displayCoord[0]),
          utm: that.formatToUTM(displayCoord[1], displayCoord[0])
        };
      });

      // 2. Listener para el Puntero (Tiempo Real)
      this.map.on('pointermove', this.handlePointerMove);

      this.map.addInteraction(drawPoint);
      if (this.map.getTargetElement()) {
        this.map.getTargetElement().style.cursor = 'crosshair';
      }
    },

    handlePointerMove(evt) {
      if (evt.dragging) return;
      const coordinate = this.map.getEventCoordinate(evt.originalEvent);
      const displayCoord = transform(coordinate, this.map.getView().getProjection(), 'EPSG:4326');
      
      this.pointerPoint = {
        lat: displayCoord[1],
        lon: displayCoord[0],
        dms: this.formatToDMS(displayCoord[1], displayCoord[0]),
        utm: this.formatToUTM(displayCoord[1], displayCoord[0])
      };
    },

    removeMeasureLocationInteraction(deleteDrawing) {
      if (!this.map) return;

      if (drawPoint) {
        this.map.removeInteraction(drawPoint);
        drawPoint = null;
      }
      
      this.map.un('pointermove', this.handlePointerMove);

      if (this.map.getTargetElement()) {
        this.map.getTargetElement().style.cursor = '';
      }

      if (deleteDrawing) {
        sourceLocation.clear();
        this.fixedPoint = null;
        this.pointerPoint = null;
        this.map.removeLayer(vectorLocation);
        
        // Reiniciar fuente y capa para asegurar un estado limpio
        sourceLocation = new VectorSource();
        vectorLocation = new VectorLayer({
          source: sourceLocation,
          zIndex: 2000, 
          style: new Style({
            image: new Icon({
              anchor: [0.5, 1],
              src: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
              scale: 0.5,
              crossOrigin: 'anonymous'
            })
          })
        });
      }
    },

    formatToDMS(lat, lon) {
      const convert = (val) => {
        const absolute = Math.abs(val);
        const degrees = Math.floor(absolute);
        const minutesNotTruncated = (absolute - degrees) * 60;
        const minutes = Math.floor(minutesNotTruncated);
        const seconds = ((minutesNotTruncated - minutes) * 60).toFixed(0);
        return `${degrees}°${minutes}'${seconds}"`;
      };

      return {
        lat: `${convert(lat)}${lat >= 0 ? 'N' : 'S'}`,
        lon: `${convert(lon)}${lon >= 0 ? 'E' : 'W'}`
      };
    },

    // Misma convención Este/Norte/Zona/Hemisferio que Locator.vue (pestaña
    // UTM del Localizador), para que ambas herramientas hablen el mismo
    // idioma de coordenadas.
    formatToUTM(lat, lon) {
      const zone = Math.floor((lon + 180) / 6) + 1;
      const hemisferio = lat >= 0 ? 'N' : 'S';
      const utmStr = `+proj=utm +zone=${zone}${hemisferio === 'S' ? ' +south' : ''} +datum=WGS84 +units=m +no_defs`;
      const [x, y] = proj4('WGS84', utmStr, [lon, lat]);
      return { x, y, zone, hemisferio };
    },

    cleanMeasureLocation() {
      sourceLocation.clear();
      this.fixedPoint = null;
      this.pointerPoint = null;
    }
  }
}
